module.exports = __webpack_public_path__ + "static/img/bg-pt.af2eb314.png";